<template>
	<div class="height-100">
		<div class="text-end">
			<div
				v-if="text"
				class="bubble"
				:class="{
					'bubble-kids kids-bubble-bottom-left': gameMode === 'kids',
					'bubble-adults adults-bubble-bottom-left': gameMode === 'adults',
					'no-margin': !isMarginRequired,
					'bubble-kids-animate': playerOneStatus && gameMode === 'kids',
					'bubble-adults-animate': playerOneStatus && gameMode === 'adults',
				}"
			>
				<ElementHeadlineSmall v-for="txt of text" class="bubble--text" :key="txt" :content="txt" i18n />
			</div>
		</div>
		<div :class="className"></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'speachBubbleWithImageLeft',
	props: {
		className: [String, Object],
		text: Array,
		isMarginRequired: Boolean,
		playerOneStatus: Boolean,
	},
	computed: {
		...mapState(['gameMode']),
	},
};
</script>
